module.exports = __webpack_public_path__ + "src/img/menu-toggler-r.fcdfe00f.svg";